import type { PageCode } from './../../../../definitions/codes';

export type UseDaysTillDeleteProps = {
	daysTillDelete?: number;
	code: PageCode;
};

export type UseDaysTillDeleteReturn = {
	isDaysTillDeleteVisible: boolean;
	isLessThan10Days: boolean;
	daysTillDeleteText: string;
	daysTillDeletePrefix: string;
};

export enum DaysTillDeleteThresholds {
	TODAY = 0,
	TOMORROW = 1,
	DAYS10 = 10,
}
